const SESSION_KEYS = ['isLoggedIn', 'userName', 'role', 'token', 'tokenExpire', 'viewType', 'locationStore']

export function readSession(storage) {
  const token = storage.getItem('token') || ''
  return {
    isLoggedIn: storage.getItem('isLoggedIn') === 'true' && !!token,
    userName: storage.getItem('userName') || '',
    role: storage.getItem('role') || '0',
    token,
    tokenExpire: storage.getItem('tokenExpire') || '',
    viewType: storage.getItem('viewType') || '3'
  }
}

export function saveSession(storage, data, fallbackName = '') {
  if (!data || !data.accessToken) throw new Error('登录结果缺少访问令牌，请重新登录')
  clearSession(storage)
  const session = {
    isLoggedIn: true,
    userName: data.username || fallbackName,
    role: String(data.role ?? '0'),
    token: data.accessToken,
    tokenExpire: String(data.accessTokenExpire || ''),
    viewType: String(data.viewType ?? '3')
  }
  Object.entries(session).forEach(([key, value]) => storage.setItem(key, value))
  return session
}

export function clearSession(storage) {
  SESSION_KEYS.forEach(key => storage.removeItem(key))
}
